import { createAction } from "redux-actions";

import { moduleSlug } from "modules/Queues/services/constants";

export const clearQueues = createAction(`${moduleSlug}/CLEAR_QUEUES`);

export const getSQSQueues = createAction(`${moduleSlug}/GET_SQS_QUEUES`);
export const getSQSQueuesSuccess = createAction(`${moduleSlug}/GET_SQS_QUEUES/SUCCESS`);
export const getSQSQueuesError = createAction(`${moduleSlug}/GET_SQS_QUEUES/ERROR`);
